"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetInitialSearchResultsData = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _constants = require("../constants");
var _loadSearchResultsData = require("./loadSearchResultsData");
var _mapSearchResultsPageQueryToProductListingRows = require("./mapSearchResultsPageQueryToProductListingRows");
var _mapSearchResultsPageQueryToRelatedQueries = require("./mapSearchResultsPageQueryToRelatedQueries");
/* istanbul ignore file @preserve -- api */ const useGetInitialSearchResultsData = (param)=>{
    let { query } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers, loading } = (0, _presentationHttp.useHeaders)();
    const { data, error } = (0, _fetching.useSWR)(loading || !query ? null : [
        query,
        headers
    ], async ()=>(0, _loadSearchResultsData.loadSearchResultsData)({
            graphQlNetUrl,
            headers,
            limit: _constants.SERVER_PAGINATION_LIMIT_ROWS,
            orderBy: _constants.DEFAULT_ORDER_BY,
            query,
            skip: 0,
            facetFiltering: [],
            withRelatedLinks: true
        }), (0, _presentationUtils.getRetryErrorSwrOptions)());
    const result = (0, _react.useMemo)(()=>({
            loaded: !!data || !!error || !(0, _presentationUtils.isSSR)() && !query,
            data: data ? (0, _mapSearchResultsPageQueryToProductListingRows.mapSearchResultsPageQueryToProductListingRows)(data) : undefined,
            queries: data ? (0, _mapSearchResultsPageQueryToRelatedQueries.mapSearchResultsPageQueryToRelatedQueries)(data) : undefined
        }), [
        data,
        error,
        query
    ]);
    return result;
};
exports.useGetInitialSearchResultsData = useGetInitialSearchResultsData;
